import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { buildUrl, prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SellerInfo,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}sellers`;

export const getSellersRequest = (): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSellersQuery = async (): Promise<
  BackResponseFailure | BackResponse<SellerInfo[]>
> => {
  try {
    return await executeQuery<BackResponse<SellerInfo[]>>(getSellersRequest());
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
